module.exports = __webpack_public_path__ + "img/classification2.e27da98e.png";